angular.module('picmonicng').factory('Shares', [
  '$resource',
  function ($resource) {
    return $resource('/api/v3/shares/:shareId/:resource', {
      shareId: '@id',
      resource: '@resource',
    });
  },
]);
